<template>
  <div>
    <div class="Bleft">
      <Form ref="formDynamic" :model="formDynamic" :label-width="80">
        <List border size="small">
          <ListItem>
            <Col span="3">事由:</Col>
            <Col span="19">{{ shiyou }}</Col>
          </ListItem>
          <ListItem>
            <Col span="3">期望交付日期:</Col>
            <Col span="19">{{ jiaofuData }}</Col>
          </ListItem>
          <ListItem>
            <Col span="3">收货信息:</Col>
            <Col span="19">{{ shouhuoInfo }}</Col>
          </ListItem>
          <ListItem>
            <Col span="3">物流单号:</Col>
            <Col span="19">{{ TrackingNum }}</Col>
          </ListItem>
        </List>
        <!-- 表格 -->
        <h4 style="margin: 10px 0">明细:</h4>
        <Row :gutter="5">
          <Col span="24">
            <Table
              :columns="tableCols"
              :data="data2"
              :table="table"
              :border="table.border"
              :stripe="table.stripe"
              :header="table.header"
              :footer="table.footer"
              :columns-list="tableCols"
            >
            </Table
          ></Col>
        </Row>
        <div v-show="block">
          <h4 style="margin: 10px 0">备注:</h4>
          <Input
            style="margin-bottom: 10px"
            v-model="takeGoodsOption"
            type="textarea"
            :autosize="{ minRows: 1, maxRows: 2 }"
          ></Input>
        </div>
      </Form>
    </div>
    <h3 class="zong">总价:{{ zongjia }}元</h3>
    <RadioGroup v-model="animal" @on-change="showReason">
      <Radio label="数量准确,确认收货"></Radio>
      <Radio label="数量有误,联系管理员"></Radio>
    </RadioGroup>
    <div v-show="show">
      <h4 style="margin: 10px 0">原因:</h4>
      <Input
        style="margin-bottom: 10px"
        v-model="returnRemark"
        type="textarea"
        :autosize="{ minRows: 1, maxRows: 2 }"
      ></Input>
    </div>
    <div style="margin-top: 10px">
      <Button type="primary" @click="handleSubmit(show ? 7 : 5)">提交</Button>
    </div>
  </div>
</template>
<script>
import { Select } from "view-design";
import { IMAGE_HOST } from "@/../config";
export default {
  props: {
    item: "",
  },
  data() {
    return {
      returnRemark: "",
      show: false,
      block: true,
      animal: "数量准确,确认收货",
      takeGoodsOption: "",
      TrackingNum: 0,
      zongjia: 0,
      shiyou: "",
      jiaofuData: "",
      shouhuoInfo: "",
      num: "",
      table: {
        mname: "consumables",
        key: "id",
        url: {},
        output: false,
        border: true,
        rows: [],
        stripe: true,
        header: false,
        footer: false,
        order: "",
        router: {
          add: "",
          edit: "",
        },
      },
      formDynamic: {},
      index: 1,
      data2: [],
      tableCols: [
        {
          title: "序号",
          type: "index",
          width: 65,
          align: "center",
        },
        {
          title: "货物信息",
          width: 275,
          align: "center",
          render: (h, p) => {
            return h(
              "div",
              {
                style: {
                  height: "80px",
                  display: "flex",
                },
              },
              [
                h("img", {
                  style: {
                    width: "60px",
                    height: "60px",
                    margin: "10px",
                    display: "block",
                  },
                  attrs: { src: IMAGE_HOST + p.row.consumableImgUrl },
                }),
                h("div", [
                  h(
                    "p",
                    {
                      style: {
                        marginTop: "10px",
                        textAlign: "left",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      },
                      domProps: {
                        title: p.row.brand + p.row.name,
                      },
                    },
                    p.row.brand + p.row.name
                  ),

                  h(
                    "p",
                    {
                      style: {
                        textAlign: "left",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        display: p.row.model == null ? "none" : "block",
                      },
                      domProps: {
                        title: "型号:" + p.row.model,
                      },
                    },
                    "型  号: " + p.row.model
                  ),
                  h(
                    "p",
                    {
                      style: {
                        textAlign: "left",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        display: p.row.remark == null ? "none" : "block",
                      },
                      domProps: {
                        title: "适用于: " + p.row.remark,
                      },
                    },
                    "适用于: " + p.row.remark
                  ),
                ]),
              ]
            );
          },
        },
        {
          title: "公/本仓",
          key: "text",
          minWidth: 65,
          align: "center",
        },
        {
          title: "申请数",
          key: "alertNum",
          minWidth: 60,
          align: "center",
        },
        {
          title: "单位",
          key: "unit",
          minWidth: 65,
          align: "center",
          render: (h, params) => {
            const row = params.row;
            const text = row.unit;
            return <span style={{ "font-size": "14px" }}>{text}</span>;
          },
        },
        {
          title: "单价/元",
          key: "unitPrice",
          minWidth: 65,
          align: "center",
          render: (h, params) => {
            const row = params.row;
            const text = row.unitPrice;
            return <span style={{ "font-size": "14px" }}>{text}</span>;
          },
        },
        {
          title: "发货数量",
          key: "shipmentQuantity",
          minWidth: 120,
          align: "center",
        },
      ],
      obj: {},
      typearr: [],
    };
  },
  async created() {
    await this.info();
  },
  methods: {
    showReason() {
      if (this.animal === "数量有误,联系管理员") {
        this.show = true;
        this.block = false;
      } else {
        this.show = false;
        this.block = true;
      }
    },
    async info() {
      let id = this.item;
      let res = await $utils.api.load(`/admin/system/procurementWork/${id}`);
      if (res.code == 200) {
        this.zongjia = res.data.totalPrice ? res.data.totalPrice.toFixed(2) : 0;
        this.shiyou = res.data.becauseWork;
        this.TrackingNum = res.data.logisticsTrackingNum;
        if (res.data.needTime) {
          var date = res.data.needTime;
          this.jiaofuData = date.split("T")[0];
        }
        this.shouhuoInfo = res.data.receivingInformation;
        let arr = res.data.sysProcurementDetails;
        this.obj = res.data;
        for (let i = 0; i < arr.length; i++) {
          let obj = {};
          obj.consumableNum = arr[i].consumableNum;
          obj.consumableImgUrl = arr[i].consumableImgUrl;
          obj.brand = arr[i].brand;
          obj.name = arr[i].name;
          obj.model = arr[i].model;
          obj.remark = arr[i].remark;
          obj.num = arr[i].num;
          obj.id = arr[i].id;
          obj.unit = arr[i].unit;
          obj.alertNum = arr[i].alertNum;
          obj.shipmentQuantity = arr[i].shipmentQuantity;
          obj.unitPrice = arr[i].unitPrice;
          let ownNum = arr[i].ownNum == null ? 0 : arr[i].ownNum;
          let adminNum = arr[i].adminNum == null ? 0 : arr[i].adminNum;
          obj.text = adminNum + "/" + ownNum;
          obj.adminAlertNum = arr[i].adminAlertNum == null ? 0 : arr[i].adminAlertNum;
          obj.index = i;
          this.data2.push(obj);
        }
      }
    },
    async handleSubmit(num) {
      let q = this.obj;
      q.state = num;
      q.takeGoodsOption = this.takeGoodsOption;
      q.returnRemark = this.returnRemark;
      let res = await $utils.api.load("/admin/system/procurementWork/edit", q, "post");
      if (res.code == 200) {
        if (num == 7) {
          await $utils.toast.success("提交成功,请尽快联系管理员");
        } else {
          await $utils.toast.success("收货成功");
        }
        this.$Modal.remove();
        setTimeout(function () {
          $utils.url.go(0);
        }, 1000);
      } else {
        $utils.toast.error(res.message);
      }
    },
  },
};
</script>
